import React from 'react';
import { AnimateBlock, FullWidthBackground, HTML, ImageBase, Link, Media } from '../../components';
import { Col, Grid, Row } from '../../grid';
import { block } from '../../utils';
import i18n from './i18n';
import './Security.css';
const b = block('SecurityBlock');
export const SecurityBlock = (props) => {
    const { backgroundColor, theme = 'dark', title, points, media, animated } = props;
    return (React.createElement(AnimateBlock, { className: b({ theme }), offset: 200, animate: animated },
        React.createElement("div", { className: b('content') },
            React.createElement(FullWidthBackground, { className: b('background'), style: { backgroundColor } }),
            React.createElement(Grid, null,
                React.createElement(Row, null,
                    React.createElement(Col, null,
                        React.createElement("h2", { className: b('title') }, title))),
                points && (React.createElement(Row, { className: b('points') }, points.map(({ text, link, img }, index) => (React.createElement(Col, { key: index, className: b('point'), sizes: { sm: 4, all: 12 } },
                    React.createElement(ImageBase, { className: b('point-icon'), src: img, alt: text || i18n('image-alt') }),
                    React.createElement(HTML, { className: b('point-text'), block: true }, text),
                    link && (React.createElement(Link, { className: b('point-link'), text: link.text, url: link.url, theme: 'normal', arrow: true }))))))),
                media && (React.createElement(Row, { className: b('media') },
                    React.createElement(Col, null,
                        React.createElement(Media, Object.assign({ className: b('media') }, media)))))))));
};
export default SecurityBlock;
